import { AavoToastContent } from "./types";
import React from "react";
import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export const AavoToastContext = React.createContext<AavoToastContextValue | undefined>(undefined);

export interface AavoToastContextValue {
	showToast: ShowToastFunc;
	closeToast: () => void;
}

export type ShowToastFunc = (content: AavoToastContent) => void;

export const useAavoToast = () => useContextOrThrow(AavoToastContext);
